import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'antd';

export default function CustomInput({
  error,
  label,
  touched,
  className,
  ...rest
}) {
  return (
    <Form.Item
      hasFeedback={touched && !!error}
      help={touched && error}
      label={label}
      validateStatus={touched && error ? 'error' : ''}
      className={className}
    >
      <Input {...rest} />
    </Form.Item>
  );
}

CustomInput.propTypes = {
  error: PropTypes.string,
  label: PropTypes.string,
  touched: PropTypes.bool,
  className: PropTypes.string,
};

CustomInput.defaultProps = {
  error: undefined,
  label: undefined,
  touched: false,
  className: undefined,
};
